<template>
	<div class="flex gap-2 relative">
		<div @click="status = 'opened'">
			<Icon
				class="cursor-pointer"
				icon="mage:dots"
				width="1.2em"
				height="1.2em"
			/>
		</div>
		<ul
			ref="optionsRef"
			:class="status"
			class="list absolute bg-gray-light w-fit rounded-md min-w-max z-10 shadow-md left-8"
		>
			<li
				v-for="option in options"
				:key="option.event"
				class="flex gap-2 items-center px-4 py-1.5 first:rounded-t-md last:rounded-b-md hover:bg-blue-base hover:text-white-neutral cursor-pointer"
				@click="
					$emit(option.event)
					status = 'closed'
				"
			>
				<Icon
					v-if="option.icon"
					class="text-lg"
					:icon="option.icon"
				/>
				<span>{{ option.name }}</span>
			</li>
		</ul>
	</div>
</template>

<script setup>
import { Icon } from '@iconify/vue2'
import { onClickOutside } from '@vueuse/core'
import { ref } from 'vue'

const status = ref('idle')
const optionsRef = ref()

defineProps({
	options: {
		type: Array,
		required: true,
	},
})

onClickOutside(optionsRef, () => {
	if (status.value === 'opened') {
		status.value = 'closed'
	}
})
</script>

<style>
.opened.list {
	animation: pop_in 0.1s linear forwards;
}

.closed.list {
	animation: pop_out 0.1s linear forwards;
}

.idle.list {
	display: none;
}

@keyframes pop_in {
	from {
		transform: scale(0.1);
	}

	to {
		transform: scale(1);
	}
}

@keyframes pop_out {
	from {
		transform: scale(1);
	}

	to {
		transform: scale(0.1);
		display: none;
	}
}

.v-application ol,
.v-application ul {
	padding-left: 0 !important;
}
</style>
